module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/beauty_man-mobile-1cd948f62c8361b702e8386e8717c6ef.jpg";